var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { AppHeader } from '@teliaee/telia-megamenu';
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import Config from '../Config';
import { navigate } from '@teliaee/crm-components';
import { removeLanguageSlug } from '../util/PathUtil';
import { injectStores } from '../util/StoresUtil';
let HeaderContainer = class HeaderContainer extends Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "ssoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "headerLocalPaths", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ['/', '/konto']
        });
    }
    render() {
        const { ssoStore, translateStore: { currentLanguage, setLanguage, translations } } = this;
        return (React.createElement(AppHeader, { brand: "diil", lang: currentLanguage, translations: translations, tier: Config.environment, app: "selfservice", onPathChange: (event) => {
                if (!(event.metaKey || event.ctrlKey || event.altKey) &&
                    event.currentTarget.host === window.location.host &&
                    this.headerLocalPaths.includes(removeLanguageSlug(event.currentTarget.pathname))) {
                    event.preventDefault();
                    navigate(event.currentTarget.pathname);
                }
            }, currentPath: location.pathname, loginOptions: ssoStore.ssoFrameVisible ? { authLevel: 2 } : undefined, ssoClient: ssoStore.ssoClient, ssoClientState: ssoStore.ssoClientState, disableSoftAuth: true, onLangChange: setLanguage, isSPA: true }));
    }
};
HeaderContainer = __decorate([
    injectStores,
    observer
], HeaderContainer);
export default HeaderContainer;
